import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import { IUser, IUsers, IUserState } from "../interfaces/IUser";



const initialState: IUserState = {
    user: null,
    users: []
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserValues: (state, action: PayloadAction<IUserState>) => {
            state.user = action.payload.user;
        },
        setUsers: (state, action: PayloadAction<IUserState>) => {
            console.log("Action",action);
            state.users = action.payload.users
        }
    }
})

export const {setUserValues, setUsers} = userSlice.actions;

export const selectUser = (state: RootState) => state.user;
export const selectUsers = (state: RootState) => state.users;

export default userSlice.reducer;